import { render, staticRenderFns } from "./AirView.vue?vue&type=template&id=2a2c87b3"
import script from "./AirView.vue?vue&type=script&lang=js"
export * from "./AirView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports